require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./services-planning-ecommerce-email-setup.json") })
        }
      }, "path---services-planning-ecommerce-email-setup");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---services-planning-ecommerce-email-setup!./.cache/json/services-planning-ecommerce-email-setup.json
// module id = 769
// module chunks = 231608221292675